import React, { FC } from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export type DirectionalCardContainerProps = {
  layout: 'horizontal' | 'vertical';
  border?: boolean;
  className?: string;
};

export const DirectionalCardContainer: FC<DirectionalCardContainerProps> = ({
  layout,
  border,
  className,
  children,
}) => {
  return (
    <div
      data-testid="directional-card-container"
      className={classnames(
        styles.container,
        styles[layout],
        { [styles.border]: border },
        className
      )}
    >
      {children}
    </div>
  );
};
